import { IFetchCouponList } from '@/services/couponTypes';
import { useCallback, useState } from 'react';

interface IFetchOrderCouponsParams {
  goodsProducts: Array<{
    goodsId: string;
    productId?: string;
    supplierId?: number;
    price: number;
    num: number;
    categoryId?: number;
  }>;
  type: 'MERCHANT' | 'PLATFORM';
  available: boolean;
  ticketNos?: string[];
}

interface IFetchOrderCouponCalcParams {
  goodsProducts: Array<{
    goodsId: number;
    productId: number;
    supplierId: number;
    price: number;
    num: number;
    categoryId: number;
  }>;
  ticketNos: Array<string>;
  type: 'ALL' | 'PLATFORM' | 'MERCHANT';
}

interface IConfirmProductProps {
  totalInfo?: {
    totalDiscountAmount: number;
    paidAmount: number;
    totalAmount: number;
  };
  changingCouponType?: IFetchOrderCouponCalcParams['type'];
  platformCoupon?: {
    enable: boolean;
    coupon?: NonNullable<IFetchCouponList['result']>[0];
    discountAmount?: number;
  };
  businessCoupon?: {
    enable: boolean;
    coupon?: NonNullable<IFetchCouponList['result']>[0];
    discountAmount?: number;
  };
  checked?: any;
  detail?: any;
}

// 设置规格数量
export default function useProductPropsModel() {
  const [productProps, setProductProps] = useState<IConfirmProductProps>({});
  const setChooseProps = useCallback((obj: IConfirmProductProps) => {
    // console.log('setChooseProps:', obj);
    if (obj) {
      setProductProps(obj);
    }
  }, []);
  const emptyChooseProps = useCallback(() => {
    setProductProps({});
  }, []);

  return {
    productProps,
    setChooseProps,
    emptyChooseProps,
  };
}
